import Index from '@/views/exhibitor/booth/Index.vue';
import Top from '@/views/exhibitor/booth/Top.vue';
import New from '@/views/exhibitor/booth/New.vue';
import Edit from '@/views/exhibitor/booth/Edit.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'booth',
    component: Index,
    children: [
      {
        name: 'exhibitor-booth-top',
        path: '',
        component: Top,
        meta: {
          title: 'ブース詳細',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-booth-new',
        path: 'new',
        component: New,
        meta: {
          title: 'ブース新規追加',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-booth-edit',
        path: 'edit',
        component: Edit,
        meta: {
          title: 'ブース編集',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
